module.exports = __webpack_public_path__ + "img/14_8.87ab9882.png";